module.exports = __webpack_public_path__ + "static/media/MaidIcon.698fec73.svg";